import React, { useRef } from 'react';
import { P5CanvasInstance, ReactP5Wrapper } from '@p5-wrapper/react';

export const PerlinNoise: React.FC = (props) => {
    const p5ref = useRef<P5CanvasInstance>();
    function sketch(p5: P5CanvasInstance) {
        p5ref.current = p5;
        const width = 640;
        const height = 240;

        let speed: number = 0.0;

        p5.setup = () => {
            p5.createCanvas(width, height);
            p5.background(240);
            p5.colorMode("hsb");
        }

        p5.draw = () => {
            const xoffval = 0.01;
            const yoffval = 0.01;

            p5.noiseDetail(5, 0.5);
            p5.loadPixels();

            let xoff = 0.0;
            for (let x = 0; x < width; x++) {
                let yoff = 0.0;
                for (let y = 0; y < height; y++) {
                    // Calculate brightness
                    const bright = p5.map(p5.noise(xoff, yoff, speed), 0, 1, 0, 255);

                    // Calculate hue
                    const hue = p5.map(p5.noise(xoff, yoff, speed), 0, 1, 0, 90);
                    const col = p5.color(hue, 200, bright);

                    p5.set(x, y, col);
                    yoff += yoffval;
                }

                xoff += xoffval;
            }

            speed += 0.01;
            p5.updatePixels();
        };
    }

    return <ReactP5Wrapper sketch={sketch} />;
};

export default PerlinNoise;